






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class App extends Vue {

  private defaultLayout: string = 'default';

  get layout(): string {
    return (this.$route.meta.layout || this.defaultLayout) + '-layout';
  }

}
